import Vue from 'vue';
import vuex from 'vuex';
import axios from 'axios';
import postFun from "@/plugins/postFun.js";
Vue.use(vuex)

export default new vuex.Store({
	state: {
		danMu:'',
		card:'',
		task:'',
		shareUrl:'',
		userInfo: '',
		mobshow: '',
		pcshow: '',
		giftnum: 1,
		giftCode: '',
		giftList: [{
			"id": 1,
			"code": "",
			"type": 20,
			"status": 0
		}, {
			"id": 2,
			"code": "",
			"type": 21,
			"status": 0
		}, {
			"id": 3,
			"code": "",
			"type": 22,
			"status": 0
		}, {
			"id": 4,
			"code": "",
			"status": 0
		}, {
			"id": 5,
			"code": "",
			"type": "",
			"status": 0
		}, {
			"id": 6,
			"code": "",
			"type": "",
			"status": 0
		}, {
			"id": 7,
			"code": "",
			"type": "",
			"status": 0
		}],
		language: 'china',
		languages: '',
		lagCode: 'en-us',
		languageData: '',
		alllanguageData: '',
		allnum: 1,
		allnum2: 1,
		allnum3:1,
		token: '',
		drawNumber: 0,
		alert1: false,
		alert2: false,
		alert3: false,
		alert4: false,
		alert5: false,
		alert6: false,
		alert7: false,
		mobshowfooter:false
	},
	mutations: {
		saveToken(state, data) {
			state.token = data;
		},
		userInfofun(state, data) {
			state.userInfo = data;
		},
		onchangemob(state, data) {
			state.mobshow = data;
		},
		mobshowfooterfun(state, data){
			state.mobshowfooter = data;
		},
		onchangePc(state, data) {
			state.pcshow = data;
		},
		languagesDataFun(state, data) {
			state.alllanguageData = data;
			state.languageData = data[state.language];
			state.lagCode = data[state.language].lagCode
		},
		changeLanguage(state, language) {
			state.languageData = state.alllanguageData[language];
			state.lagCode = state.alllanguageData[language].lagCode
			state.language = language;
		},
		changeAllnum(state, num) {
			state.allnum = num;
			// console.log(num);
			state.allnum3=JSON.stringify(num).replace(/\B(?=(\d{3})+$)/g,',');
			// console.log(s);
		},
		alert1Fun(state, type) {
			state.alert1 = type;
			state.alert2 = false;
			state.alert3 = false;
			state.alert4 = false;
			state.alert5 = false;
			state.alert6 = false;
			state.alert7 = false;
		},
		alert2Fun(state, type) {
			state.alert1 = false;
			state.alert2 = type;
			state.alert3 = false;
			state.alert4 = false;
			state.alert5 = false;
			state.alert6 = false;
			state.alert7 = false;
		},
		alert3Fun(state, type) {
			state.alert1 = false;
			state.alert2 = false;
			state.alert3 = type;
			state.alert4 = false;
			state.alert5 = false;
			state.alert6 = false;
			state.alert7 = false;
		},
		alert4Fun(state, type) {
			state.alert1 = false;
			state.alert2 = false;
			state.alert3 = false;
			state.alert4 = type;
			state.alert5 = false;
			state.alert6 = false;
			state.alert7 = false;
		},
		alert5Fun(state, type) {
			state.alert1 = false;
			state.alert2 = false;
			state.alert3 = false;
			state.alert4 = false;
			state.alert5 = type;
			state.alert6 = false;
			state.alert7 = false;
		},
		alert6Fun(state, type) {
			state.alert1 = false;
			state.alert2 = false;
			state.alert3 = false;
			state.alert4 = false;
			state.alert5 = false;
			state.alert6 = type;
			state.alert7 = false;
		},
		alert7Fun(state, type) {
			state.alert1 = false;
			state.alert2 = false;
			state.alert3 = false;
			state.alert4 = false;
			state.alert5 = false;
			state.alert6 = false;
			state.alert7 = type;
			state.shareUrl=window.location.href + '&invite_code=' + state.userInfo.invite_code
		},
	},
	getters: {},
	actions: {
		getlanguageData() {
			return new Promise(resolve => {
				axios.get('language.json').then(res => {
					// console.log(res.data)
					this.commit("languagesDataFun", res.data.data);
					resolve(res)
				})
			})
		}
	},
	modules: {}
})